import React, { useEffect, useState } from 'react';
import { FormItem } from './common/formValidations';
import fetchWrapper from './helpers/fetchWrapper';
import { getFormData } from './helpers/helperService';
import { Row } from 'antd';

const UnitHierarchy = ({ form, level = 8 }) => {
	const [fields, setFields] = useState([]);
	const [locationsCondition, setLocationsCondition] = useState({});

	const fetchFormElms = async () => {
		const form_elms = await getFormData('geo_location');
		const { form_element } = form_elms;
		const sections = form_element?.sec_1 ?? [];
		setFields((level === 8 ? sections : sections.slice(0, -1)) ?? []);
	};
	const initialLoad = () => {
		fetchFormElms();
		form.setFieldsValue({ level_1: 'Consolidated Brac University' });
	};
	const formChangeHandler = async (e) => {
		const { name, value } = e.target;
		const level_id = name.split('_')[1];
		if (level_id && value.length > 0) {
			try {
				const payload = {
					level: Number(level_id),
					ids: value,
				};
				level === 7 && (payload.level8 = false);
				const res = await fetchWrapper.post('/global/geo_location_data', payload);
				const obj_entries = Object.entries(res.data);
				const conditions = {};
				const values = {};
				obj_entries.map((item) => {
					const condition =
						item[0] === '8'
							? `config_cost_centers.cost_center_id IN ( ${item[1].join(',')} )`
							: `bud_budget_units.budget_unit_id IN ( ${item[1].join(',')} )`;
					if (Number(item[0] > Number(level_id))) {
						conditions[`level_${item[0]}`] = condition;
					}
					values[`level_${item[0]}`] = item[1];
				});
				setLocationsCondition((prev) => ({ ...prev, ...conditions }));
				form.setFieldsValue(values);
			} catch (error) {}
		} else if (level_id && value.length === 0) {
			const conditions = {};
			const values = {};
			for (let i = Number(level_id); i <= 8; i++) {
				// conditions[`level_${i}`] = '';
				values[`level_${i}`] = [];
			}
			setLocationsCondition((prev) => ({ ...prev, ...conditions }));
			form.setFieldsValue(values);
		}
	};
	useEffect(() => {
		initialLoad();
	}, []);
	return (
		<Row gutter={16}>
			{fields?.map((field, index) => (
				<FormItem
					key={field.input_name}
					field={{
						...field,
						extra: `${index + 1 === 8 ? 'config_cost_centers' : 'bud_budget_units'}.level_type = '${
							index + 1
						}'${
							locationsCondition[field.input_name] ? ` AND ${locationsCondition[field.input_name]}` : ''
						}`,
					}}
					getEvent={formChangeHandler}
				/>
			))}
		</Row>
	);
};

export default UnitHierarchy;
